import React, { Component } from "react";
import { Link } from "react-router-dom";

class NavItem extends Component {
    constructor(props){
        super(props);
    }
    
    handleClick = (e) => {
        const { path, onItemClick } = this.props;
        onItemClick(path);
        if(e.target && e.target.closest('.mobile-menu-bar')){
            this.props.closeHandler();
        }
    }

    render() {
        const { active } = this.props;
        return (
            <React.Fragment>
                {this.props.title &&
                    <li className="side-nav-title side-nav-item">{this.props.title}</li>
                }

                <li className={active ? 'side-nav-item mm-active' : 'side-nav-item'} id={this.props.id}>
                    <Link to={this.props.path} className="side-nav-link" onClick={this.handleClick}>
                        <i className={this.props.css}></i>
                        <span> {this.props.name} </span>
                    </Link>
                </li>
            </React.Fragment>
        );
    }
}
export default NavItem;